<div class="flex flex-col gap-2 lg:hidden">
  @for (projectIndustry of projectIndustries(); track projectIndustry?.id) {
    <div class="flex w-full min-w-0 items-center p-4 rounded-md bg-proffeo-surface border border-proffeo-border gap-4">
      <div
        class="flex items-center justify-center min-w-10 w-10 min-h-10 h-10 bg-proffeo-action-primary rounded-full shrink-0"
      >
        <mat-icon
          fontIcon="construction"
          class="icon-white"
        />
      </div>
      <div class="flex min-w-0 flex-1 items-center gap-2">
        <p class="min-w-0 flex-1 break-words">
          {{ projectIndustry.industry().name }}
        </p>
        <proffeo-avatar
          (click)="selectIndustryAdmin($safeNavigationMigration(projectIndustry?.administrator()), projectIndustry)"
          [user]="$safeNavigationMigration(projectIndustry?.administrator())"
          [borderType]="AvatarBorderType.IndustryAdmin"
          [size]="AvatarSize.SM"
        />
        <mat-icon
          [matMenuTriggerFor]="matIndustriesMenu"
          fontIcon="more_vert"
          class="cursor-pointer shrink-0"
        />
        <mat-menu #matIndustriesMenu>
          <div class="flex h-full w-full flex-col">
            <div
              (click)="openIndustryDeleteConfirmationDialog(projectIndustry)"
              class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 group hover:bg-proffeo-accent transition-default"
            >
              <mat-icon
                fontIcon="edit"
                class="group-hover:icon-white"
              />
              <p class="group-hover:icon-white">
                {{ 'project-industries.list-actions.delete' | translate }}
              </p>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
  } @empty {
    <div class="flex w-full p-4 items-center justify-center">
      <p>{{ 'placeholders.no-results-found' | translate }}</p>
    </div>
  }
</div>

<div class="hidden lg:flex w-full">
  <ng-template
    #adminCell
    let-projectIndustry
  >
    <proffeo-avatar
      (click)="selectIndustryAdmin(projectIndustry.administrator(), projectIndustry)"
      [user]="projectIndustry.administrator()"
      [borderType]="AvatarBorderType.IndustryAdmin"
      [size]="AvatarSize.SM"
    />
  </ng-template>

  <proffeo-ui-table
    (actionClick)="onTableAction($event)"
    [columns]="columns()"
    [emptyText]="'placeholders.no-results-found' | translate"
    [rowActions]="rowActions()"
    [rowId]="resolveRowId"
    [rows]="projectIndustries()"
    [tableAriaLabel]="'project-industries.table-headers.name' | translate"
    orderMode="none"
    class="w-full"
  />
</div>
